import { fireClearCodeEvent, goToPage } from "../../../editor/events";

import type { StepType } from "@reactour/tour";
import { typeSomeText } from "../../common";
import TourStepContent from "../../wrapper";
import { text, translateJadleToLocale } from "@quickpoint.me/shared";

const t = () => text.tourSteps;

function getActionTexts() {
	const s = t();
	return [
		s.basicsSomeWords + ".",
		translateJadleToLocale(`title: ${s.basicsSomeWords}`),
		translateJadleToLocale("\n  color: third"),
		translateJadleToLocale(`background: sigmund\n  blur: 5\n  opacity: 90\ntitle: ${s.basicsYourWords}\n  shadow:over-image\n#:${s.basicsPowerfullyExpressive}\n  shadow:over-image\n#: ${s.basicsEssentialCivilisation}\n  shadow:over-image\nblank:4\n`),
		translateJadleToLocale(`\nsubtitle: ${s.basicsCivilizationQuote}\n  size: 5  \n  shadow:over-image\n${s.basicsSigmundFreud}\n  align:right\n  size: 4\n  shadow:over-image`),
		"\n===",
		translateJadleToLocale(`\ntitle: ${s.basicsPage2Title}\n${s.basicsPage2Content}\n`),
		translateJadleToLocale(`\nsupertitle: ${s.basicsSupertitle} \ntitle: ${s.basicsThisIsTitle} \nsubtitle: ${s.basicsThisIsSmaller}  \n${s.basicsSomeParagraph}`),
		translateJadleToLocale("  color: third\n. align:right\n"),
		"",
		translateJadleToLocale(`image:bauhaus interior\n  caption: ${s.bauhausInteriorCaption}\n|\nsupertitle: ${s.basicsFiltersTitle}\ntitle: ${s.basicsCanMakeIdeas}\nsubtitle: ${s.basicsFeelDifferent}\n${s.basicsFiltersParagraph}`),
		translateJadleToLocale("\nfilter:quickpoint::tufte\n\n"),
		translateJadleToLocale("\nfilter:quickpoint::caruso-italia\n\n"),
		translateJadleToLocale("\nfilter:quickpoint::nyt\n\n"),
		translateJadleToLocale(" align: left"),
	];
}

const basics = (hostId: string): StepType[] => [
	{
		selector: ".author-root",
		position: "center",
		content: () => (
			<TourStepContent description={() => <strong>{text.tourSteps.basicsTitle}</strong>} />
		),
	},
	{
		selector: ".author-root",
		position: "center",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.basicsSimpleIdea}
					</span>
				)}
			/>
		),
	},
	{
		selector: ".author-root",
		position: "center",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						<span className="qp-tour-keyword">title:</span> {text.tourSteps.basicsKeywordTitle}
						<span className="qp-tour-keyword">image:</span> {text.tourSteps.basicsKeywordImage}
						<span className="qp-tour-keyword">===</span> {text.tourSteps.basicsKeywordNewPage}
					</span>
				)}
			/>
		),
	},
	{
		selector: ".qp-editor",
		position: "left",
		content: () => (
			<TourStepContent description={() => <span>{text.tourSteps.basicsEditorIntro}</span>} />
		),
	},
	{
		selector: "#landscape-viewer",
		position: "left",
		content: () => (
			<TourStepContent
				description={() => <span>{text.tourSteps.basicsViewerIntro}</span>}
			/>
		),
	},
	{
		selector: ".qp-editor",
		position: "center",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.basicsSimplePrompt}
					</span>
				)}
			/>
		),
		action: () => {
			fireClearCodeEvent();
		},
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.basicsTypePrefix} <span className="qp-tour-keyword">title:</span> {text.tourSteps.basicsTypeTitleSuffix}
					</span>
				)}
			/>
		),
		action: () => {
			const a = getActionTexts();
			typeSomeText({ text: a[1], prefill: "" });
		},
	},
	{
		selector: "#landscape-viewer",
		position: "left",
		content: () => (
			<TourStepContent
				description={() => <span>{text.tourSteps.basicsWordsAppearAsTitle}</span>}
			/>
		),
		action: () => {
			fireClearCodeEvent();
			const a = getActionTexts();
			typeSomeText({ text: "", prefill: a[1] });
		},
	},
	{
		selector: "#landscape-viewer",
		position: "left",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.basicsTitleInRed}
					</span>
				)}
			/>
		),
		action: () => {
			fireClearCodeEvent();
			const a = getActionTexts();
			typeSomeText({ text: a[2], prefill: a[1] });
		},
	},
	{
		selector: ".cm-line:nth-of-type(2)",
		position: "left",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.basicsTypeTabColor}{" "}
						<span className="qp-tour-modifier">color:</span> {text.tourSteps.basicsTypeTabColorSuffix}
					</span>
				)}
			/>
		),
		action: () => {
			fireClearCodeEvent();
			const a = getActionTexts();
			typeSomeText({ text: "", prefill: a[1] + a[2] });
		},
	},

	{
		selector: ".cm-line:nth-of-type(2)",
		position: "left",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.basicsIndentationExplainer}
					</span>
				)}
			/>
		),
	},
	{
		selector: ".cm-line:nth-of-type(3)",
		position: "left",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.basicsMultipleModifiers}
					</span>
				)}
			/>
		),
		action: () => {
			fireClearCodeEvent();
			const a = getActionTexts();
			typeSomeText({
				text: a[14],
				prefill: `${a[1]}${a[2]}\n`,
			});
		},
	},
	{
		selector: "#landscape-viewer",
		position: "left",
		content: () => (
			<TourStepContent
				description={() => <span>{text.tourSteps.basicsTitleAppearsRed}</span>}
			/>
		),
	},
	{
		selector: ".qp-editor",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.basicsTypePrefix} <span className="qp-tour-modifier">===</span> {text.tourSteps.basicsTypeNewPageOrig}
					</span>
				)}
			/>
		),
		action: () => {
			fireClearCodeEvent();
			const a = getActionTexts();
			typeSomeText({
				text: a[5] + a[6],
				prefill: a[1] + a[2],
			});
		},
	},
	{
		selector: ".qp-hints",
		content: () => (
			<TourStepContent description={() => text.tourSteps.basicsHintsIntro} />
		),
	},
	{
		selector: ".qp-hints",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.basicsHintsLiveUpdate}
					</span>
				)}
			/>
		),
	},
	{
		selector: "#landscape-viewer",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.basicsFilterIntroPrefix}{" "}
						<span className="qp-tour-keyword">filter:</span> {text.tourSteps.basicsFilterIntroSuffix}
					</span>
				)}
			/>
		),
		action: () => {
			fireClearCodeEvent();
			const a = getActionTexts();
			typeSomeText({ text: "", prefill: a[10] });
			goToPage(hostId, "QP", 1);
		},
	},
	{
		selector: "#landscape-viewer",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.basicsFilterIntroPrefix}{" "}
						<span className="qp-tour-keyword">filter:</span> {text.tourSteps.basicsFilterIntroSuffix}
					</span>
				)}
			/>
		),
		action: () => {
			fireClearCodeEvent();
			const a = getActionTexts();
			typeSomeText({ text: "", prefill: a[11] + a[10] });
			goToPage(hostId, "QP", 1);
		},
	},
	{
		selector: "#landscape-viewer",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.basicsFilterIntroPrefix}{" "}
						<span className="qp-tour-keyword">filter:</span> {text.tourSteps.basicsFilterIntroSuffix}
					</span>
				)}
			/>
		),
		action: () => {
			fireClearCodeEvent();
			const a = getActionTexts();
			typeSomeText({ text: "", prefill: a[12] + a[10] });
		},
	},
	{
		selector: "#landscape-viewer",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.basicsFilterIntroPrefix}{" "}
						<span className="qp-tour-keyword">filter:</span> {text.tourSteps.basicsFilterIntroSuffix}
					</span>
				)}
			/>
		),
		action: () => {
			fireClearCodeEvent();
			const a = getActionTexts();
			typeSomeText({ text: "", prefill: a[13] + a[10] });
		},
	},
	{
		selector: "#landscape-viewer",
		content: () => (
			<TourStepContent description={() => text.tourSteps.basicsCoreIdea} />
		),
		action: () => {
			fireClearCodeEvent();
			const a = getActionTexts();
			typeSomeText({ text: a[3] + a[4] });
		},
	},
	{
		selector: ".author-root",
		position: "center",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						{text.tourSteps.basicsCoveredBasics}
					</span>
				)}
			/>
		),
	},
];

export default basics;
